import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from '@web/atoms';
import { QuizCallout } from '@web/components';
import { Caption, StyledQuestion, Subheading } from './styles';

export const Question = React.forwardRef(
  // @ts-ignore
  (
    {
      children,
      caption,
      prompt,
      callout,
      as,
      bgColor = 'background.base',
      subheadline,
      isUIVariant,
      typography = 'heading3',
      hideCaptionOrCallout = false,
      hideSubheadlineOnMobile = false,
      gap = 3,
      padding = [0, 5, 5, 5],
      calloutMargin,
    },
    ref,
  ) => {
    return (
      <StyledQuestion
        ref={ref}
        as={as}
        data-testid="onboarding-question"
        $bgColor={bgColor}
        isUIVariant={isUIVariant}
        $gap={gap}
        $padding={padding}
      >
        <Heading
          headingLevel="h3"
          headingText={prompt}
          position="center"
          typography={typography}
          backgroundColor={bgColor}
          isUIVariant={isUIVariant}
          verticalPadding={1}
        />
        {subheadline && (
          <Subheading $hideSubheadlineOnMobile={hideSubheadlineOnMobile}>
            {subheadline}
          </Subheading>
        )}
        {children}
        {caption && (
          <Caption $hideCaption={hideCaptionOrCallout}>{caption}</Caption>
        )}
        {callout && (
          <QuizCallout
            margin={calloutMargin}
            hideCallout={hideCaptionOrCallout}
            {...callout}
          />
        )}
      </StyledQuestion>
    );
  },
);

Question.displayName = 'Question';
Question.propTypes = {
  children: PropTypes.node,
  prompt: PropTypes.string.isRequired,
  caption: PropTypes.string,
  as: PropTypes.string,
  bgColor: PropTypes.string,
  subheadline: PropTypes.string,
  typography: PropTypes.string,
  hideCaptionOrCallout: PropTypes.bool,
  hideSubheadlineOnMobile: PropTypes.bool,
  gap: PropTypes.number,
  padding: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  callout: PropTypes.object,
  calloutMargin: PropTypes.arrayOf(PropTypes.number),
};
